// SEO das páginas do menu (/menu/<nome>) — INC-0283 (cs2586), vale para TODOS os sites.
// Antes a página punha <title>{titulo}</title> e o <SiteHead pagina="home"> logo depois sobrescrevia com o
// title/description da HOME (todas as páginas do menu saíam com o SEO da home). Agora o SiteHead recebe
// titleOverride/descriptionOverride montados aqui. Funções PURAS: SSR e cliente dão o mesmo texto.
import { clampTexto, stripTags } from './descricaoRica';

// Entidades que o editor do CRM costuma gravar além das que o stripTags já resolve (&nbsp; &amp; &quot;
// &#39; &lt; &gt;): acentos do português, aspas/travessões tipográficos e as numéricas (&#225; &#xE1;).
const ENTIDADES: Record<string, string> = {
    aacute: 'á', eacute: 'é', iacute: 'í', oacute: 'ó', uacute: 'ú',
    Aacute: 'Á', Eacute: 'É', Iacute: 'Í', Oacute: 'Ó', Uacute: 'Ú',
    agrave: 'à', Agrave: 'À', acirc: 'â', ecirc: 'ê', ocirc: 'ô', Acirc: 'Â', Ecirc: 'Ê', Ocirc: 'Ô',
    atilde: 'ã', otilde: 'õ', Atilde: 'Ã', Otilde: 'Õ', ccedil: 'ç', Ccedil: 'Ç', uuml: 'ü', Uuml: 'Ü',
    ordm: 'º', ordf: 'ª', deg: '°', middot: '·', bull: '•', hellip: '…', ndash: '–', mdash: '—',
    ldquo: '“', rdquo: '”', lsquo: '‘', rsquo: '’', laquo: '«', raquo: '»', copy: '©', reg: '®',
};

const decodificaEntidades = (texto: string): string =>
    texto
        .replace(/&#x([0-9a-f]{1,6});/gi, (_t, hex) => {
            const n = parseInt(hex, 16);
            return n > 0 && n <= 0x10ffff ? String.fromCodePoint(n) : ' ';
        })
        .replace(/&#(\d{1,7});/g, (_t, dec) => {
            const n = Number(dec);
            return n > 0 && n <= 0x10ffff ? String.fromCodePoint(n) : ' ';
        })
        .replace(/&([a-zA-Z]+);/g, (_t, nome) => ENTIDADES[nome] ?? ' ');

/** Nome do site no fim do title: o nome da empresa (Dados.empresa) que o SiteHead já usa; sem ele, o título do site. */
const nomeDoSite = (site: any): string =>
    String(site?.Dados?.empresa || site?.titulo || '').replace(/\s+/g, ' ').trim();

/** "<título da página> | <nome do site>" (espaços repetidos do cadastro viram um só). '' sem título. */
export const tituloPaginaMenu = (tituloMenu: unknown, site: any): string => {
    const titulo = String(tituloMenu ?? '').replace(/\s+/g, ' ').trim();
    if (!titulo) return '';
    const nome = nomeDoSite(site);
    return nome && nome.toLowerCase() !== titulo.toLowerCase() ? `${titulo} | ${nome}` : titulo;
};

/** Início do texto da página sem HTML (~155 caracteres, cortado em palavra). '' sem texto (= description da home). */
export const descricaoPaginaMenu = (conteudoHtml: unknown, max = 155): string => {
    const html = typeof conteudoHtml === 'string' ? conteudoHtml : '';
    if (!html.trim()) return '';
    const texto = decodificaEntidades(stripTags(html.replace(/<!--[\s\S]*?-->/g, ' ')))
        .replace(/\s+/g, ' ')
        .trim();
    return clampTexto(texto, max);
};
